var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html, LitElement } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import styles from './icon.styles';
import { watch } from '../../internal/watch';
/**
 * @status in-work
 *
 * @csspart base - The component's base wrapper.
 * @cssproperty --icon-fill-color - To set the fill color of the svg, default: "currentColor"
 */
let SgdfIcon = class SgdfIcon extends LitElement {
    constructor() {
        super(...arguments);
        /** The name of the icon to draw. */
        this.name = '';
        /** An external URL of an SVG file. */
        this.src = '';
        /** An alternate description to use for accessibility. If omitted, the icon will be ignored by assistive devices. */
        this.label = '';
        /** The name of a registered custom icon library. */
        this.library = 'solid';
    }
    onNameUpdate() {
        this.src = `/assets/icons/${this.library}.svg#${this.name}`;
    }
    render() {
        const hasLabel = typeof this.label === 'string' && this.label.length > 0;
        return html ` <div
            part="base"
            class="icon"
            role=${ifDefined(hasLabel ? 'img' : undefined)}
            aria-label=${ifDefined(hasLabel ? this.label : undefined)}
            aria-hidden=${ifDefined(hasLabel ? undefined : 'true')}
        >
            <svg>
                <use href="${this.src}"></use>
            </svg>
        </div>`;
    }
};
SgdfIcon.styles = styles;
__decorate([
    property({
        reflect: true,
        type: String,
    })
], SgdfIcon.prototype, "name", void 0);
__decorate([
    state()
], SgdfIcon.prototype, "src", void 0);
__decorate([
    property()
], SgdfIcon.prototype, "label", void 0);
__decorate([
    property()
], SgdfIcon.prototype, "library", void 0);
__decorate([
    watch(['name', 'library'])
], SgdfIcon.prototype, "onNameUpdate", null);
SgdfIcon = __decorate([
    customElement('sgdf-icon')
], SgdfIcon);
export default SgdfIcon;
//# sourceMappingURL=icon.js.map